export type DataSource =
  | 'ecw'
  | 'php'
  | 'wpc'
  | 'safety_net'
  | 'clarity'
  | 'epic_csv'
  | 'smart_care'
  | 'org_default'

export type DataEntity =
  | 'client'
  | 'care_gap'
  | 'appointment'
  | 'order'
  | 'provider'
  | 'timeslot'
  | 'visit'

export interface UploadFormData {
  source: DataSource | null
  entity: DataEntity
  file: File | null
}

export interface UploadResponse {
  success: boolean
  file_id: string
  error?: string
}

export const DATA_SOURCES: { value: DataSource | ''; label: string }[] = [
  { value: '', label: 'Select source' },
  { value: 'ecw', label: 'eClinicalWorks' },
  { value: 'php', label: 'Partnership HealthPlan' },
  { value: 'wpc', label: 'WPC' },
  { value: 'safety_net', label: 'Safety Net' },
  { value: 'clarity', label: 'Clarity' },
  { value: 'epic_csv', label: 'Epic' },
  { value: 'smart_care', label: 'Smart Care' },
]

export const MAX_FILE_SIZE_BYTES = 30 * 1024 * 1024 // 30MB

export const DEFAULT_FORM_DATA: UploadFormData = {
  source: null,
  entity: 'client',
  file: null,
}

/**
 * Expected file name patterns for each entity and source combination.
 * Used to guide users on what files to look for when importing data.
 */
export const FILE_NAME_HINTS: Partial<
  Record<DataEntity, Partial<Record<DataSource, string[]>>>
> = {
  client: {
    ecw: ['Patient Demographic Report - <start date> - <end date>'],
    php: ['Copy of YYYY.MM.DD PHP Membership List.csv'],
    safety_net: ['CalOMS Basic Demographics with Insurances'],
    clarity: [
      'ritter_center_enrollees.csv',
      'ritter_center_enrollees-MMYYYY.csv',
    ],
  },
  appointment: {
    ecw: [
      '4.14 - Next Day Appointments - DDMMYYYY - DDMMYYYY',
      'PatientDemoGraphicData_MMDDYYYY_MMDDYYYY.csv',
    ],
  },
  provider: {
    ecw: [
      '43.06 - Practice Providers -DDMMYYYY.csv',
      '43.06 - Practice Providers.csv',
    ],
  },
  visit: {
    ecw: ['4.02 - Encounter Patient Download -MMYYYY.csv'],
    safety_net: ['YYYY.MM.DD Ritter Clients by DOS'],
    clarity: [
      'ritter_center_service_summary-MMYYYY.csv',
      'ritter_center_service_summary.csv',
    ],
  },
}
